export default __webpack_public_path__ + "static/media/double-single-border-left.9c078952.svg";